import { LegalLinks } from "../views/Legal/LegalLayout";

function Footer() {
    return (
        <footer className="border-t border-gray-200 bg-white">
            <div className="w-full px-4 py-4 sm:px-6 lg:px-8">
                <div className="flex flex-col gap-2 text-sm text-gray-600 sm:flex-row sm:items-center sm:justify-between">
                    <p className="font-medium text-gray-700">ANFGC Halifax</p>
                    <p>© {new Date().getFullYear()} To train and raise leaders for the body of Christ. 2 Timothy 2:2</p>
                    <LegalLinks className="text-sm text-gray-500" />
                </div>
            </div>
        </footer>
    );
}

export default Footer;
